import React, { useState } from 'react';
import DocumentHead from 'components/DocumentHead';

import useScrollToTop from 'hooks/useScrollToTop';
import ThreeCards from 'components/signUp/ThreeCards';

const SignUpAdvertiser = () => {
  const [openForm, setOpenForm] = useState({ advertiser: false, influencer: false, agency: false });
  useScrollToTop();

  const contentOne = (
    <span>
      I want to
      <br /> promote myself <br /> (buy a shoutout)
    </span>
  );

  return (
    <>
      <DocumentHead>
        <title>Advertiser | GigSocial</title>
      </DocumentHead>

      <ThreeCards
        openForm={openForm}
        setOpenForm={setOpenForm}
        contentOne={contentOne}
        contentTwo="I want to promote my company’s product or my clients"
        hasThirdCard={false}
      />
    </>
  );
};

export default SignUpAdvertiser;
